export type genericType = {
  [key: string | number]:
    | { [key: string | number]: string | number | boolean }
    | { [key: string | number]: string | number | boolean }[]
    | string
    | number
    | boolean;
};

const initialData = {
  token: "",
  refreshToken: "",
  source: "",
};

export const updateStore = (
  storeKeyName?: string,
  storeKeyValue?:
    | { [key: string | number]: string | number | boolean }
    | { [key: string | number]: string | number | boolean }[]
    | string
    | number
    | boolean
) => {
  const storeData = JSON?.parse(
    localStorage?.getItem("store:speech-evaluation") as string
  );
  if (!storeKeyName && !storeKeyValue) {
    localStorage.setItem(
      "store:speech-evaluation",
      JSON.stringify({ ...initialData })
    );
  } else {
    storeData &&
      localStorage.setItem(
        "store:speech-evaluation",
        JSON.stringify({
          ...storeData,
          [storeKeyName as string]: storeKeyValue,
        })
      );
  }
};

export const getStoreValue = (storeKeyValue: string) => {
  const storeData = JSON?.parse(
    localStorage?.getItem("store:speech-evaluation") as string
  );
  if (storeData && storeKeyValue && storeData[storeKeyValue]) {
    return storeData[storeKeyValue];
  } else {
    return null;
  }
};

export const clearStore = (storeKeyValue?: string) => {
  if (storeKeyValue) {
    localStorage.removeItem(storeKeyValue);
  } else {
    localStorage.clear();
  }
};
